// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/lib/ionic1.x-common/services/alert/notification.scss
// module id = 101
// module chunks = 0